// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 400 ? "a46ce55c" : chunkId) + "." + {"400":"ce2681c5d978066a","718":"76ef4cae66f4a821"}[chunkId] + ".js";
};